import styled from 'styled-components';

export const StyledBoundariesSubtotals = styled.div`
  display: flex;
`;

export const StyledLabel = styled.span`
  margin-left: 0.5rem;
`;
